import { DEFAULT_LOCALE } from './constants';
import { EnLang, LocaleConfig } from './locales';

export const appLocale: Record<string, LocaleConfig> = {
  [DEFAULT_LOCALE]: EnLang,
};
